export default "__VITE_PUBLIC_ASSET__d30c6e75__"